import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL, USER_URL } from '../../constant/api';

function ProfileView() {
  const [personalInfo, setPersonalInfo] = useState({});
  const [organizationInfo, setOrganizationInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch personal information
  const fetchPersonalInfo = async () => {
    try {
      const response = await USER_URL.get(`/accounts/profile-update/`);
      // Assuming the API returns your personal data under data.Data
      setPersonalInfo(response.data.Data[0]);
    } catch (error) {
      console.error('Error fetching personal info:', error);
    }
  };
  

  // Fetch organization information
  const fetchOrganizationInfo = async () => {
    try {
      const response = await USER_URL.get(`/accounts/organization/`);
      // Assuming the API returns your organization data under data.Data
      setOrganizationInfo(response.data.data[0]);
    } catch (error) {
      console.error('Error fetching organization info:', error);
      // If there is an error fetching organization info, leave it null.
      setOrganizationInfo(null);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      // Run both API calls in parallel.
      await Promise.all([fetchPersonalInfo(), fetchOrganizationInfo()]);
      setIsLoading(false);
    };
    fetchData();
  }, []);

  console.log({ personalInfo, organizationInfo });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="h-auto w-full p-10">
      {/* Personal Information Section */}
      <div className="w-full my-4">
        <h2 className="font-bold text-[18px] pb-5 text-brand-primary">Personal Information</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="flex flex-col">
            <label className="text-gray-600 text-sm font-bold">Name</label>
            <p className="border border-gray-300 p-3 rounded bg-gray-100">
              {personalInfo.first_name
                ? `${personalInfo.first_name} ${personalInfo.last_name}`
                : personalInfo.username || 'N/A'}
            </p>
          </div>
          <div className="flex flex-col">
            <label className="text-gray-600 text-sm font-bold">Phone Number</label>
            <p className="border border-gray-300 p-3 rounded bg-gray-100">
              {personalInfo.mobile_number || 'N/A'}
            </p>
          </div>
          <div className="flex flex-col">
            <label className="text-gray-600 text-sm font-bold">Email</label>
            <p className="border border-gray-300 p-3 rounded bg-gray-100">
              {personalInfo.email || 'N/A'}
            </p>
          </div>
          <div className="flex flex-col">
            <label className="text-gray-600 text-sm font-bold">Address</label>
            <p className="border border-gray-300 p-3 rounded bg-gray-100">
              {personalInfo.address || 'N/A'}
            </p>
          </div>
          <div className="flex flex-col">
            <label className="text-gray-600 text-sm font-bold">Post Code</label>
            <p className="border border-gray-300 p-3 rounded bg-gray-100">
              {personalInfo.post_code || 'N/A'}
            </p>
          </div>
          <div className="flex flex-col">
            <label className="text-gray-600 text-sm font-bold">City</label>
            <p className="border border-gray-300 p-3 rounded bg-gray-100">
              {personalInfo.city || 'N/A'}
            </p>
          </div>
          <div className="flex flex-col">
            <label className="text-gray-600 text-sm font-bold">State</label>
            <p className="border border-gray-300 p-3 rounded bg-gray-100">
              {personalInfo.state || 'N/A'}
            </p>
          </div>
          <div className="flex flex-col">
            <label className="text-gray-600 text-sm font-bold">Country</label>
            <p className="border border-gray-300 p-3 rounded bg-gray-100">
              {personalInfo.country || 'N/A'}
            </p>
          </div>
        </div>
      </div>

      {/* Organization Information Section (only if available) */}
      {organizationInfo && (
        <div className="w-full my-10">
          <h2 className="font-bold text-[18px] pb-5 text-brand-primary">Organization Information</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="flex flex-col">
              <label className="text-gray-600 text-sm font-bold">Organization Name</label>
              <p className="border border-gray-300 p-3 rounded bg-gray-100">
                {organizationInfo.name || 'N/A'}
              </p>
            </div>
            <div className="flex flex-col">
              <label className="text-gray-600 text-sm font-bold">License Number</label>
              <p className="border border-gray-300 p-3 rounded bg-gray-100">
                {organizationInfo.license_number || 'N/A'}
              </p>
            </div>
            <div className="flex flex-col">
              <label className="text-gray-600 text-sm font-bold">Bank Name</label>
              <p className="border border-gray-300 p-3 rounded bg-gray-100">
                {organizationInfo.bank_name || 'N/A'}
              </p>
            </div>
            <div className="flex flex-col">
              <label className="text-gray-600 text-sm font-bold">Account Number</label>
              <p className="border border-gray-300 p-3 rounded bg-gray-100">
                {organizationInfo.account_number || 'N/A'}
              </p>
            </div>
            <div className="flex flex-col">
              <label className="text-gray-600 text-sm font-bold">IFSC</label>
              <p className="border border-gray-300 p-3 rounded bg-gray-100">
                {organizationInfo.ifsc || 'N/A'}
              </p>
            </div>
            <div className="flex flex-col">
              <label className="text-gray-600 text-sm font-bold">Tax Number</label>
              <p className="border border-gray-300 p-3 rounded bg-gray-100">
                {organizationInfo.tax_number || 'N/A'}
              </p>
            </div>
            <div className="flex flex-col">
              <label className="text-gray-600 text-sm font-bold">Organization Address</label>
              <p className="border border-gray-300 p-3 rounded bg-gray-100">
                {organizationInfo.address || 'N/A'}
              </p>
            </div>
            <div className="flex flex-col">
              <label className="text-gray-600 text-sm font-bold">Location</label>
              <p className="border border-gray-300 p-3 rounded bg-gray-100">
                {organizationInfo.location || 'N/A'}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Additional Information Section */}
      <div>
        <h1 className="font-semibold text-[18px] my-2">About Us</h1>
        <p className="font-normal text-[16px] text-justify">
          bricknmix is transforming online shopping into an experience and aims to enrich your shopping list wisely. We offer a wide range of products with fast delivery and 24/7 customer service for a seamless shopping experience.
        </p>
        <h1 className="font-semibold text-[18px] my-2">24/7 Customer Support</h1>
        <p className="font-normal text-[16px] text-justify">
          The bricknmix support team works around the clock for our customers. We give high priority to troubleshooting and resolving any complaints or issues, ensuring our customers always have a smile on their face.
        </p>
      </div>
    </div>
  );
}

export default ProfileView;

